import { IResource } from '@gettactic/api';
import { ResourceType } from '../../../api';
import { mapToRange } from '../strings/mapToRange';

export const resourcesDefaultImages: Partial<Record<ResourceType, string[]>> = {
  desk: [
    'https://cdn.gettactic.com/images/default/desk.png',
    'https://cdn.gettactic.com/images/default/desk_1.png',
    'https://cdn.gettactic.com/images/default/desk_2.png',
    'https://cdn.gettactic.com/images/default/desk_3.png',
    'https://cdn.gettactic.com/images/default/desk_4.png'
  ],
  meeting_room: [
    'https://cdn.gettactic.com/images/default/room.png',
    'https://cdn.gettactic.com/images/default/room_1.png',
    'https://cdn.gettactic.com/images/default/room_1.png',
    'https://cdn.gettactic.com/images/default/room_1.png',
    'https://cdn.gettactic.com/images/default/room_1.png'
  ]
};

export const getResourceCoverUrl = (
  resource: Partial<IResource>,
  width = 200,
  onlyImage = false
) => {
  if (!width) return undefined;
  const mediaVariants = onlyImage
    ? resource?.image_variants
    : resource?.media_variants;
  //TODO FIX THIS TYPE
  const resourceMediaOriginalUrl = (
    mediaVariants?.[0] as unknown as { original: string }
  )?.original as string | undefined;

  return resourceMediaOriginalUrl
    ? `${resourceMediaOriginalUrl}/w=${width}`
    : resourcesDefaultImages?.[resource.type || 'desk']?.[
        mapToRange(
          resource.id || '',
          resourcesDefaultImages?.[resource.type || 'desk']?.length || 4
        ) - 1
      ] || undefined;
};
